import {
  error as oldError,
  warn,
  info,
} from '@xhs/logger'

let defaultTransport = {}

function configDefaultTransport(transport) {
  defaultTransport = transport
}

function error(message, meta, group, transport) {
  oldError(message, meta, group, transport || defaultTransport)
}

export {
  configDefaultTransport,
  error,
  warn,
  info,
}
